import tablefree from "../Assets/tableEmpty.png";
import tableOccupied from "../Assets/tableOccupied.png";
import NotFound from "../Assets/404.webp";

export const Images = {
  tablefree,
  tableOccupied,
  NotFound
};
